import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/htx/comorbidities/endocrinologistOpinion";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	endocrinologistOpinion: {
		id: "form.endocrinologist_opinion",
		defaultMessage: "Endokrinológia"
	},
	value: {
		id: "form.endocrinologist_opinion.value",
		defaultMessage: "Szakvizsgálat történt?"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["result"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "endocrinologistOpinion",
	value: {
		title: messages.endocrinologistOpinion,
		validator,
		fieldset
	}
};
